import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "../ui/dialog";
import { Textarea } from "../ui/textarea";
import { Button } from "../ui/button";

export const ReasonModal = ({ open, onOpenChange, title, description, confirmLabel = "Confirm", onConfirm, destructive = true }) => {
  const [reason, setReason] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleConfirm = async () => {
    if (!reason.trim()) return;
    setSubmitting(true);
    try {
      await onConfirm(reason.trim());
      setReason("");
      onOpenChange(false);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="reason-modal">
        <DialogHeader>
          <DialogTitle className="font-extrabold uppercase">{title}</DialogTitle>
          <DialogDescription>{description}</DialogDescription>
        </DialogHeader>
        <Textarea
          data-testid="reason-modal-textarea"
          placeholder="Enter a reason (required)..."
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          className="min-h-[100px]"
        />
        <DialogFooter>
          <Button variant="outline" data-testid="reason-modal-cancel" onClick={() => onOpenChange(false)} className="rounded-full font-bold">
            Cancel
          </Button>
          <Button
            data-testid="reason-modal-confirm"
            onClick={handleConfirm}
            disabled={!reason.trim() || submitting}
            className={`rounded-full font-bold ${destructive ? "bg-red-600 hover:bg-red-700" : "bg-stranger-orange hover:bg-orange-600"} text-clean-white`}
          >
            {submitting ? "Submitting..." : confirmLabel}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
